import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { TranquiTheme } from './theme';
import Btn from '../../components/Btn/Btn';
import { getImageUrl } from '../../utils/imagesRoot';

interface ErorPageProps {
  onGoHome: () => void;
}

const ErorPage: React.FC<ErorPageProps> = ({ onGoHome }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const history = useHistory();
  const goHome = () => {
    onGoHome();
    history.push('/');
  };

  return (
    <main className={classes.root}>
      <div className={classes.wrapper}>
        <img src={getImageUrl('404.png')} alt="Error 404" className={classes.img} />
        <h1 className={classes.title}>Lo sentimos, esta página no está disponible actualmente.</h1>
        <p className={classes.text}>Puedes intentar ingresando nuevamente o volviendo al inicio.</p>
        <Btn color="secondary" variant="outlined" onClick={goHome}>Volver al inicio</Btn>
      </div>
    </main>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    minHeight: '100vh',

  },
  wrapper: {
    padding: theme.spacing(5),
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
  },
  img: {
    width: '100%',
    maxWidth: 350,
    marginBottom: theme.spacing(3),
  },
  title: {
    ...theme.typography.h3,
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
  text: {
    maxWidth: 820,
    textAlign: 'center',
    ...theme.typography.body1,
  },
}));

export default ErorPage;
